var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"50px"}},[_c('div',{staticClass:"BPCheaderIcon",style:(`background-image: url(${_vm.logoTheme() || '/favicon-primary.png'});`)}),_c('BAServices')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }